import { render, staticRenderFns } from "./materials-info.component.vue?vue&type=template&id=601e56c0&scoped=true&"
import script from "./materials-info.component.ts?vue&type=script&lang=ts&"
export * from "./materials-info.component.ts?vue&type=script&lang=ts&"
import style0 from "./materials-info.component.scss?vue&type=style&index=0&id=601e56c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "601e56c0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCol,VSimpleTable})
